<template lang="pug">
  div.map-popup
    div
      div.tooltip__head
        p.title Эквидистанта
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
      div.tooltip__foot
        button(@click.prevent="more") Реестр объектов
</template>

<script>
import baseMapPopupMixin from './base-map-popup-mixin.js'
import PopupFieldsRows from './popup-fields-rows'

export default {
  name: 'map-popup-equidistant',
  components: { PopupFieldsRows },
  mixins: [baseMapPopupMixin],
  data() {
    this.closeCallback = null
    this.redirectParams = {}
  },
  methods: {
    more() {
      let route = this.redirectParams
      if (!route.params) {
        route.params = {}
      }
      if (!route.query) {
        route.query = {}
      }
      route.params.id = this.fields.id
      this.$sharedServices.router.push(route)
    },
    getExample() {
      return {
        head: '',
        fields: {},
        rows: {},
      }
    },
    injectConf(options) {
      let { model = {}, closeCallback, redirectParams = null } = options
      this.closeCallback = closeCallback
      if (model.fields) {
        this.rows = Object.assign({}, model.fields)
      }
      if (model.head) {
        this.head = model.head
      }
      if (model.model) {
        this.fields = Object.assign({}, model.model)
      } else {
        this.fields = Object.assign({}, model)
      }
      if (redirectParams) {
        this.redirectParams = redirectParams
        this.showMore = true
      } else {
        this.showMore = false
      }
      this.registerVueInMap()
    },
    close($event) {
      this.closeCallback($event)
    },
    registerClosePopup() {},
  },
}
</script>
